import classNames from 'classnames';
import React, { FC, ReactChild } from 'react';
import styles from '../styles/checkbox.module.scss';

type PropsType = {
  id: string;
  checked?: boolean;
  name: string;
  children: string | ReactChild;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handler?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  classInput?: string;
  classLabel?: string;
  disabled?: boolean;
  autocomplete?: string;
  loading?: boolean;
};

export const Checkbox = React.forwardRef<HTMLInputElement, PropsType>(
  (
    {
      id,
      checked,
      name,
      children,
      onChange,
      handler,
      className = '',
      classInput,
      classLabel,
      disabled,
      loading,
      autocomplete,
    },
    ref
  ) => {
    const child = typeof children === 'string' ? <span>{children as string}</span> : children;

    return (
      <div className={classNames(styles.checkbox, {[styles.loading]: loading}, className)}>
        <input
          ref={ref}
          className={classInput}
          id={id}
          type="checkbox"
          name={name}
          checked={checked}
          onChange={handler ? handler : onChange}
          disabled={disabled}
          autoComplete={autocomplete}
        />
        <label className={classLabel} htmlFor={id}>
          {child}
        </label>
      </div>
    );
  }
);
